import script from "./MenuList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuList.vue?vue&type=script&setup=true&lang=ts"

import "./MenuList.vue?vue&type=style&index=0&id=0e0fed90&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0fed90"]])

export default __exports__